import { Directive, OnInit } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Directive({ selector: '[auMatInputAutofocus]' })
export class AuMatInputAutofocusDirective implements OnInit {
	constructor(private matInput: MatInput) {}

	ngOnInit() {
		setTimeout(() => this.matInput.focus());
	}
}
